import { cn } from '@/lib/utils';

import Card from '@/components/atoms/Card';

import { Testimonial } from '../Testimonials';

import CompanyInfo from './CompanyInfo';
import TestimonialContent from './TestimonialContent';

type Props = {
  testimonial: Testimonial;
};

const TestimonialCard = ({ testimonial }: Props) => {
  return (
    <Card
      classNames={{
        root: cn('flex w-full p-0 border-brand-300', 'flex-col lg:flex-row'),
      }}
      roudnessLevel='m'
    >
      <CompanyInfo testimonial={testimonial} />
      <TestimonialContent testimonial={testimonial} />
    </Card>
  );
};

export default TestimonialCard;
